<template>
  <div>
  <div class="uicontainer">
    <br>
    <br>
    <div v-show="showVideo" class="video-overlay">
    <video id="sm-video" ref="toggleVideo" style="width: 100%; height: 100%;"></video>
    <button @click="closeVideo" id="close-button">Close Video</button>
    <v-spacer></v-spacer>
<button style="margin-top: 100px;" @click="toggleVideo">Toggle Video</button>

  </div>
      <div class="chatBox texts">
        <p class="reply">
                 <v-toolbar-title>
            <v-avatar size="80">
              <img src="@/assets/cogneetiv-logo-2.png">
            </v-avatar>
    
          </v-toolbar-title>
        </p>
    </div>
    <br><br><br><br><br><br><br><br>
  </div>
  <div class="footer">
<div class="mic-animate" id="start-animate" v-bind:class="{ 'start-animate': micOn }" @click="startSpeaking()">
  <AnimationCogOrb ref="wake" src="@/assets/mic.svg" class="mic2" />
  <img ref="wake" src="@/assets/mic.svg" class="mic" />
</div>
    <GmailCompose :show-email="showEmail" v-if="showEmail"></GmailCompose>
    <v-overlay :value="overlay" opacity="0.98" z-index="9">
    <v-btn class="close-btn-chat" fab dark small color="#ccc" @click="overlay = false">X</v-btn>
    <VoiceVisualizer :show-voice="showVoice" v-if="showVoice"></VoiceVisualizer>
    <Celebrations :show-celebrate="showCelebrate" v-if="showCelebrate"></Celebrations>
    </v-overlay>    
    <Animation6 class="animation2" />
    <!-- <WakeUpWord /> -->
    <p class="copyright">MACHEENIST © 2024</p>
    </div>
  </div>
</template>
<script src="smwebsdk.js" type="module" async defer></script>
<script src="index.js" async defer></script>
<script>
import { EventBus } from '../eventBus';     
// import VoiceChatUI from '../components/voicechatui/VoiceChatUI.vue';        
import startAudio from '../assets/audio/Cogneetiv-Ping-NEW.wav';
import startAudioResponse from '../assets/audio/Response5.wav';
import startAudioClose from '../assets/audio/Close.wav';
import startAudioDownload from '../assets/audio/download2.wav';
// import startAudioBrowser from '../assets/audio/browser.wav';
import startAudioResearch from '../assets/audio/research2.wav';
// import typingAudio from '../assets/audio/Typing.wav';
// import completeAudio from '../assets/audio/Complete.wav';
import startAudioVisual from '../assets/audio/CogDing.wav';
import startAudioDark from '../assets/audio/Dark.wav';
import startAudioLight from '../assets/audio/Lighttwo.wav';
import startAudioDimmer from '../assets/audio/Dimmer.wav';
// import startAudioLightTwo from '../assets/audio/Lighttwo.wav';
import startAudioChange from '../assets/audio/Change.wav';
import startAudioLightsOff from '../assets/audio/Lightsoff.wav';
import startAudioBrightOn from '../assets/audio/BrightOn.wav';
import startAudioBrightOff from '../assets/audio/BrightOff.wav';
import Animation6 from './Animation6.vue';
import AnimationCogOrb from './AnimationCogOrb.vue';
// import Animation7 from './Animation7.vue';
// import WakeUpWord from '../components/WakeUpWord.vue';
// import { EventBus } from '../Event';
import store from '../store';
// import axios from 'axios';
// import { chromium } from "playwright";
export default {
  name: 'Footer',
    props: {
    msg: String
  },
  components: {
    // WakeUpWord,
    AnimationCogOrb,
    Animation6,
    GmailCompose: () => import('@/components/GmailCompose.vue'),
    VoiceVisualizer: () => import('@/components/VoiceVisualizer.vue'),
  },
  data: () => ({
    videoActive: false,
    avatarVisible: false,
    content: '',
    speak: '',
    overlay: false,
    message: [],
    micOn: false,
    playing: false,
    showEmail: false,
    showVoice: false,
    showCelebrate: false,
    requestType: '',
    currentRoute: '',
    userInfo: {},
    mtype: null,
    media: null,
    isMobile: false,
    showVideo: false,
    autoCloseTimer: null,
    showButtons: true,
    toggleConnection: false,
    connectionStatus: 'disconnected' // 'disconnected', 'connected', 'listening', 'reset'
  }),
  created() {
    EventBus.$on('toggleVideoEvent', this.toggleVideo);
  },
  beforeDestroy() {
    EventBus.$off('toggleVideoEvent', this.toggleVideo);
  },
  methods: {
    initSpeechSynthesis() {
    speechSynthesis.onvoiceschanged = () => {
      this.availableVoices = speechSynthesis.getVoices();
      
      // Filter available voices to match preferred voices and prepare voice options for selection
      this.voiceOptions = this.availableVoices
        .filter(voice => this.preferredVoices.includes(voice.name))
        .map(voice => ({ label: voice.name, value: voice.name }));
      
      // Automatically select the first preferred voice if available
      if (this.voiceOptions.length > 0) {
        this.selectedVoiceName = this.voiceOptions[0].value;
      }
    };
  },
  
  updateSelectedVoice(voiceName) {
    this.selectedVoiceName = voiceName;
    // Update the selected voice for speech synthesis
    const selectedVoice = this.availableVoices.find(voice => voice.name === voiceName);
    if (selectedVoice) {
      this.speechSynthesisUtterance.voice = selectedVoice;
    }
  },
        addSoulMachinesScript() {
      const script = document.createElement('script');
      script.src = "https://static.soulmachines.com/widget-snippet-1.12.0.min.js";
      script.setAttribute('data-sm-api-key', "eyJzb3VsSWQiOiJkZG5hLWpvaG4tc2FsaW5hcy0tY29nLWFpLWRpZ2l0YWwtZ3JlZXRlciIsImF1dGhTZXJ2ZXIiOiJodHRwczovL2RoLmF6LnNvdWxtYWNoaW5lcy5jbG91ZC9hcGkvand0IiwiYXV0aFRva2VuIjoiYXBpa2V5X3YxX2U5YWJjMmFiLWJhMTYtNDkzNy1hODdkLWIxYzllMGE5MTc5NSJ9");
      script.setAttribute('data-sm-position', "bottomRight");
      script.setAttribute('data-sm-greeting', "Welcome to Cogneetiv AI");
      script.setAttribute('data-sm-layout', "fullFrame");
      script.setAttribute('data-sm-profile-picture', "https://macheenist.com/wp-content/assets/cogneetiv.png");
      
      // Append the script to the head
      document.head.appendChild(script);
    },
    startSpeaking() {
    if (window.startSpeaking) window.startSpeaking();
  },
  readOutLoud(msg) {
    if (window.readOutLoud) window.readOutLoud(msg);
  },
    connect() {
        window.connect();  // Call the global connect function from index.js
        this.showVideo = true;
        this.scene = true;
        EventBus.$emit('toggleVideoEvent');
        // Any other logic associated with the connect action goes here
    },
    toggleVideo() {
      this.showVideo = !this.showVideo;
      if (this.showVideo) {
        this.autoCloseTimer = setTimeout(() => {
          this.closeVideo();
        }, 25000); // Close the video after 5 seconds
      } else {
        clearTimeout(this.autoCloseTimer); // Clear the timeout if the video is manually toggled off before auto-close
      }
    },
    closeVideo() {
      this.showVideo = false;
      clearTimeout(this.autoCloseTimer); // Ensure the timer is cleared when the video is closed
      // Add any other logic you want to execute when the video closes
    },
    resetConversation() {
        // Logic to reset the conversation with the avatar goes here
    },
    speechRecognitionResult: function() {
      this.startSpeaking();
    },
    loadScripts() {
    // Load the smwebsdk.js script
    if (!document.getElementById('smwebsdk-script')) {
      const smwebsdkScript = document.createElement('script');
      smwebsdkScript.src = "smwebsdk.js";
      smwebsdkScript.type = "module";
      smwebsdkScript.async = true;
      smwebsdkScript.defer = true;
      smwebsdkScript.id = 'smwebsdk-script';
      document.head.appendChild(smwebsdkScript);
    }

    // Load the index.js script
    if (!document.getElementById('index-script')) {
      const indexScript = document.createElement('script');
      indexScript.src = "index.js";
      indexScript.async = true;
      indexScript.defer = true;
      indexScript.id = 'index-script';
      document.head.appendChild(indexScript);
    }
  },
    toggleButtons() {
        this.showButtons = !this.showButtons;
        this.showVideo = !this.showVideo;
        this.connect = !this.connect;
    },
    invokeAvatar() {
        this.showVideo = true;
        this.toggleConnection = true;
        this.connectionStatus = 'connected';
    },
    reset() {
        this.showVideo = false;
        this.connectionStatus = 'reset';
    },
      toggleConnection() {
      if (this.showVideo) {
        // If currently showing the video
        const disconnect = confirm("Do you want to disconnect from AI?");
        if (disconnect) {
          this.showVideo = false;
          console.log("Disconnected from AI.");
        }
      } else {
        // If currently not showing the video
        const connect = confirm("Do you want to connect to AI?");
        if (connect) {
          this.showVideo = true;
          console.log("Connected to AI.");
        }
      }
    },
    connect() {
      this.showVideo = true;
      this.loadSoulMachinesScript();
    },
    CameraPreview(connected, cameraOn, cameraWidth, cameraHeight) {
      // ... your CameraPreview function ...
      this.connected = connected;
      this.cameraOn = cameraOn;
      this.cameraWidth = cameraWidth;
      this.cameraHeight = cameraHeight;
    },
    TextInput() {
      // ... your TextInput function ...
      this.textInput = textInput;
    },
    sendText() {
      // ... your sendText function ...
      this.inputText = inputText;
    },
avatarSpeak(message) {
    // Your implementation to make the avatar "speak" the message
    // This might involve calling another API or using some frontend functionality
    // to display the message on the screen
    console.log(message);
},
    invokeAI() {
      this.loadSoulMachinesScript();
    },
    loadSoulMachinesScript() {
      if (!document.getElementById('soulmachines-script')) {
        const script = document.createElement('script');
        script.src = "https://static.soulmachines.com/widget-snippet-1.12.0.min.js";
        script.id = 'soulmachines-script';
        script.setAttribute('data-sm-api-key', 'YOUR_API_KEY');
        script.setAttribute('data-sm-position', 'bottomRight');
        script.setAttribute('data-sm-greeting', 'Welcome to Cogneetiv AI');
        script.setAttribute('data-sm-layout', 'fullFrame');
        script.setAttribute('data-sm-profile-picture', 'https://macheenist.com/wp-content/assets/cogneetiv.png');
        document.head.appendChild(script);
      }
    },
    startSpeaking: function() {
      new Audio(startAudio).play();

      let instance = this;
      this.recognition.stop();
      this.recognition.start();
      const searchForm = document.querySelector("#search-form");
      const searchFormInput = searchForm.querySelector("input"); // <=> document.querySelector("#search-form input");
      const info = document.querySelector(".info");
      this.texts = document.querySelector(".texts"); // Get the element.
        this.p = document.createElement("p");

      this.Device = {
          isMobile: false,
          isChrome: true
      };
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        this.Device.isMobile = true;
      }
      if (navigator.userAgent.indexOf('Chrome') == -1) {
        this.Device.isChrome = true;
      }
  this.recognition.onstart = function() {
    instance.micOn = true;

    // Display user's speech on the screen
    instance.p.textContent = '';
    instance.texts.appendChild(instance.p);
  };
  this.recognition.onend = function() {
    instance.micOn = false;
  };
  this.recognition.onerror = function() {
    instance.micOn = false;
  };
  this.recognition.onresult = function(e) {
    let transcript = e.results[0][0].transcript.toLowerCase();
    this.speak = transcript;

    instance.showDialoguePlaceholder();

    const thinkingAnimation = document.querySelector(".thinking-animation");
    const circularLoading = document.createElement("div");
    circularLoading.classList.add("circular-loading");

    for (let i = 0; i < 5; i++) {
      const neonRing = document.createElement("div");
      neonRing.classList.add("neon-ring");
      circularLoading.appendChild(neonRing);
    }

    thinkingAnimation.prepend(circularLoading);
    setTimeout(() => {
      thinkingAnimation.removeChild(circularLoading);
      instance.alfred(transcript);
    }, 500);

    if(transcript.toLowerCase().trim()==="stop") {
      this.recognition.stop();
      instance.micOn = false;
    }
    else if(instance.readOutLoud("Processing your command :" + transcript)  === "Processing your command :" + transcript) {
      instance.micOn = false;
    }
    else if(transcript.toLowerCase().trim()==="play") {
      document.getElementById("play").click();
    }
    
    else if(transcript.toLowerCase().trim()==="next song") {
      document.getElementById("next").click();
    }
    else if(transcript.toLowerCase().trim()==="previous song") {
      document.getElementById("prev").click();
    }
    if (!searchFormInput.value) {
    searchFormInput.value = transcript;
    searchFormInput.dispatchEvent(new Event("input"));
  } else {
      if(e >= document.querySelectorAll('span.gcharacter').length) {
    this.continue;
}
      else if(transcript.toLowerCase().trim()==="search") {
        searchFormInput.focus();
        searchForm.submit();
        document.getElementById("search").click();
      }
      else if(transcript.toLowerCase().trim()==="reset") {
        searchFormInput.value = "";
        transcript.replace();
      }
      else {
        searchFormInput.value = transcript;
        searchFormInput.dispatchEvent(new Event("input"));
      }
    }
    // searchFormInput.value = transcript;
    // searchFormInput.focus();
    // setTimeout(() => {
    //   searchForm.submit();
    // }, 1500);
      info.textContent = 'Commands: "Reset", "Search"';

  this.texts.appendChild(info);
    };
},
  toggleSyncAnimation(activate) {
    this.syncing = activate;
    if (this.syncing) {
      document.querySelector('.animation').classList.add('active');
    } else {
      document.querySelector('.animation').classList.remove('active');
    }
  },
showDialoguePlaceholder: function() {
  this.placeholder = document.createElement("div");
  this.placeholder.classList.add("load-wrapper");
  
  const activity = document.createElement("div");
  activity.classList.add("activity");
  this.placeholder.appendChild(activity);

  // Add circular loading animation with 5 neon light rings
  for (let i = 1; i <= 5; i++) {
    const neonRing = document.createElement("div");
    neonRing.classList.add("neon-ring");
    activity.appendChild(neonRing);
  }
  const thinkingAnimation = document.createElement("div");
  thinkingAnimation.classList.add("thinking-animation");
  
  this.thinkingText = document.createElement("p");
  this.thinkingText.classList.add("thinking-text");
  this.thinkingText.innerText = "Cogneetiv AI Analyzing...";
  thinkingAnimation.innerHTML = "Cogneetiv AI Analyzing...";
  thinkingAnimation.appendChild(this.thinkingText);
  
  this.placeholder.appendChild(thinkingAnimation);
  this.texts.appendChild(this.placeholder);
},
resetPlaceholder: function() {
  const thinkingAnimation = document.querySelector(".thinking-animation");
  thinkingAnimation.innerHTML = "";
},
removeDialoguePlaceholder: function() {
  if (this.placeholder) {
    this.placeholder.remove();
  }
},
  // async startPythonScript() {
  //   try {
  //     // Replace '/start-script' with the appropriate route in your backend server
  //     const response = await axios.post(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`);
  //     // const response = await axios.post('/browserbot.py');
  //     const { questions } = response.data;

  //     // Iterate through the questions
  //     for (const question of questions) {
  //       this.readOutLoud(question);
  //       await this.waitForAnswer();
  //     }

  //     // When all questions have been asked, process the results
  //     this.processResults(response.data);
  //   } catch (err) {
  //     console.error('Error starting Python script:', err);
  //   }
  // },
readOutLoud: function(msg) {
  new Audio(startAudioResponse).play();
  const speech = new SpeechSynthesisUtterance();
  const voiceName = 'Google UK English Female';
  const loadHeight = window.visualViewport.height;
  speech.volume = 1;
  speech.rate = 1;
  speech.pitch = 1;
  speech.voice = speechSynthesis.getVoices().filter(function (voice) {
    return voice.name === voiceName
  })[0]
  speech.text = msg;
  speechSynthesis.speak(speech);
  let instance = this;
    //  instance.readOutLoud(msg); // Add this line to call readOutLoud function
  this.speech = msg;

  // this.texts = document.querySelector(".texts");
  // this.p = document.createElement("p");
  this.p.classList.add("reply");
  this.p.innerText = msg;
  this.p.textContent = msg;
  this.p.textArray = msg;
  this.texts.appendChild(this.p);
  // window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
//  if (window.visualViewport.height < loadHeight) {
//       headerEl.style.display = 'none';
//       messagesEl.scrollTop = messagesEl.scrollHeight;
//     } else {
//       headerEl.style.display = '';
//       messagesEl.scrollTop = messagesEl.scrollHeight;
//     }
//   }
  window.visualViewport.addEventListener('resize', resizeHandler);
  function resizeHandler() {
    if (window.visualViewport.height < loadHeight) {
      this.texts.scrollTop = this.texts.scrollHeight;
    } else {
      this.texts.scrollTop = this.texts.scrollHeight;
    }

  }
  // Add event listener for word or character boundary
  speech.onboundary = function(event) {
    if (event.name === 'word' || event.name === 'char') {
      let animationElement = document.querySelector('.animation');
      animationElement.style.animation = 'none'; // Remove the existing animation
      setTimeout(() => {
        // Assign a new animation with a short duration to create a brief glow effect
        animationElement.style.animation = 'flicker 0.38s infinite';
      }, 100);
    }
  };

  speech.onend = function() {
    console.log('Finished speaking:', msg, message);
    this.toggleSyncAnimation(false);
    this.startSpeaking(); // Resume listening after speaking;
    this.resetPlaceholder(); // Add this line to reset the placeholder
    this.closeDialoguePlaceholder(); // Close the placeholder after 2 seconds
  };
  speech.onstart = function() {
    instance.toggleSyncAnimation(true); // Start the animation
    instance.thinkingText.innerText = "Cogneetiv AI Replying...";
    instance.thinkingText.style.opacity = 1;
    instance.thinkingText.classList.add("colorful-animation");
    setTimeout(() => {
      instance.removeDialoguePlaceholder();
    }, 2600);
  };
},

    listen: function() {
      this.recognition = new this.webkitSpeechRecognition();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = 'en-US';
      this.recognition.maxAlternatives = 1;
      this.recognition.start();
    },
    getTime: function() {
      let date = new Date();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      this.dialog = true;
      return strTime;
    },
    alfred: async function(msg) {
      console.log(msg);
      if (this.requestType == 'search' && msg.indexOf('search') != -1) {
        this.checkForRoutes(msg); // We will use this method to do search all over the project
        return;
      }
      if (this.requestType == 'startForm') {
        //If user has started Form ---block
        if (msg === 'verified') {
          this.requestType = '';
        } else if (msg.indexOf('cancel form') != -1) {
          this.requestType = '';
        }
        Event.$emit('formDetails', { msg });
        return;
      }

      /* NAVIGATE COMMAND */
      if (msg.indexOf('navigate') != -1) {
        this.requestType = '';
        setTimeout(() => {
        if (msg.indexOf('dashboard') != -1) {
          this.$router.push({ name: 'Dashboard' }) && this.readOutLoud('Here is your Dashboard');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('notes') != -1) {
          this.$router.push({ name: 'Notes' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('contacts') != -1) {
          this.$router.push({ name: 'Contacts' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('welcome') != -1) {
          this.$router.push({ name: 'Welcome' });
                       window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('data room') != -1) {
          this.$router.push({ name: 'Dataroom' }) && this.readOutLoud('');
                       window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('creator') != -1) {
          this.$router.push({ name: 'Creator' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('intel') != -1) {
          this.$router.push({ name: 'Intel' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('program') != -1) {
          this.$router.push({ name: 'Program' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('designer') != -1) {
          this.$router.push({ name: 'Designer' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('video player') != -1) {
          this.$router.push({ name: 'VideoPlayer' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('tasks') != -1) {
          this.$router.push({ name: 'Tasks' }) && this.readOutLoud('');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('generative') != -1) {
          this.$router.push({ name: 'GenerativeAI' }) && this.readOutLoud('Here is your Generative AI');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('interface') != -1) {
          this.$router.push({ name: 'Interface' }) && this.readOutLoud('Here is your Interface');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('mission control') != -1) {
          this.$router.push({ name: 'MissionControl' }) && this.readOutLoud('Here is your Mission Control');
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        } else if (msg.indexOf('daily briefing') != -1) {
          this.$router.push({ name: 'DailyBriefing' });
          window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        // } else if (msg.indexOf('play') != -1) {
        //   this.readOutLoud('Playing');
        //   setTimeout(function() {
        //     window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        //     document.getElementById("play").click();            
        //   }, 2000);
        // } else if (msg.indexOf('next') != -1) {
        //   window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        //   this.readOutLoud('Next Song');
        //   document.getElementById("next").click();
        // } else if (msg.indexOf('previous') != -1) {
        //   window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        //   this.readOutLoud('Previous Song');
        //   document.getElementById("prev").click();
        // } else if (msg.indexOf('pause') != -1) {
        //   window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        //   this.readOutLoud('Paused');
        //   document.getElementById("pause").click();
        }
        }, 1500); 
      } else if (msg.indexOf('logout') != -1 || msg.indexOf('log out') != -1) {
        this.$router.push({ name: 'Login' });
        return;
      } else if (msg.indexOf('dark mode') != -1 || msg.indexOf('dark') != -1) {
        new Audio(startAudioDark).play();
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        return;
      } else if (msg.indexOf('undarken') != -1) {
        new Audio(startAudioLight).play();
        this.$vuetify.theme = !this.$vuetify.theme;
        window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        return;
      } else if (msg.indexOf('next') != -1) {
        this.$refs.slick.next();
        return;
      } else if (msg.indexOf('previous') != -1) {
        this.$refs.slick.prev();
        return;
      } else if (msg.indexOf('google') !== -1) {
        //  Using "google"  word for searching content
        this.readOutLoud('Initiating Google Search for ' + msg.replace('google', '') + '');
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://www.google.com/search?q=' + msg.replace('google', ''), '_blank');
        }, 2000);
      } else if (msg.indexOf('Search Desktop') !== -1) {
        this.readOutLoud('Initiating Desktop File Search for ' + msg.replace('Search Desktop', '') + '');
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('D:Desktop' + '_blank');
        }, 2000);
      // } else if (msg.indexOf('start briefing') !== -1) {
      //   new Audio(startAudioChange).play();
      //   setTimeout(() => {
      //    window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
      //   }, 2200);
      } else if (msg.indexOf('netflix search') !== -1) {
        //  Using "google"  word for searching content
        this.readOutLoud('Initiating Netflix Search for ' + msg.replace('netflix search', '') + '');
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://www.netflix.com/search?q=' + msg.replace('netflix search', ''), '_blank');
        }, 2000);
        } else if (msg.indexOf('play song') != -1) {
          this.readOutLoud('Playing');
          setTimeout(function() {
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
            document.getElementById("play").click();            
          }, 2000);
      } else if (msg.indexOf('price search') !== -1) {
        //  Using "google"  word for searching content
        this.readOutLoud('Initiating Price Search for ' + msg.replace('price search', '') + '');
        // setTimeout(() => {
        // new Audio(startAudioChange).play();
        // window.open('https://www.ebay.com/sch/i.html?_from=R40&_trksid=p2380057.m570.l1313&_nkw=' + msg.replace('price search', ''), '_blank');
        // }, 2000);
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://www.ebay.com/sch/i.html?_from=R40&_nkw=' + msg.replace('price search', '') + '&rt=nc&LH_Sold=1&LH_Complete=1', '_blank');
        }, 2000);
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://www.backmarket.com/en-us/search?q=' + msg.replace('price search', ''), '_blank');
        }, 4000);
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://losangeles.craigslist.org/search/sss?query=' + msg.replace('price search', ''), '_blank');
        }, 6000);
        // setTimeout(() => {
        // new Audio(startAudioChange).play();
        // window.open('https://www.walmart.com/search?q=' + msg.replace('price search', ''), '_blank');
        // }, 8000);
        } else if (msg.indexOf('play song') != -1) {
          this.readOutLoud('Playing');
          setTimeout(function() {
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
            document.getElementById("play").click();            
          }, 2000);
        } else if (msg.indexOf('next song') != -1) {
          this.readOutLoud('Next Song');
          setTimeout(function() {
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
            document.getElementById("next").click();            
          }, 2000);
        } else if (msg.indexOf('previous song') != -1) {
          this.readOutLoud('Previous Song');
          setTimeout(function() {
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
            document.getElementById("prev").click();            
          }, 2000);
        } else if (msg.indexOf('pause') != -1) {
          this.readOutLoud('Paused');
          setTimeout(function() {
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
            document.getElementById("play").click();            
          }, 2000);
        // } else if (msg.indexOf('start assignment') != -1) {
        //   // this.readOutLoud('Starting Task');
        //   setTimeout(function() {
        //     window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        //     document.getElementById("play").click();            
        //   }, 2000);
      } else if (msg.indexOf('check for date and time') !== -1) {
            // const time = new Date().toLocaleTimeString();
            // const date = new Date().toLocaleDateString();
            // this.readOutLoud('The current time is ' + time + ', and the date is ' + date);
      } else if (msg.indexOf('search for') !== -1) {
            this.readOutLoud('Searching online for more information on ' + msg.replace('search for', '') + '');
            new Audio(startAudioChange).play();
      } else if (msg.indexOf('youtube') !== -1) {
            this.readOutLoud('Initiating Youtube Search for ' + msg.replace('youtube', '') + '');
            setTimeout(() => {
            new Audio(startAudioChange).play();
            window.open('https://www.youtube.com/results?search_query=' + msg.replace('youtube', ''), '_blank');
            }, 1900);
      // } else if (msg.indexOf('open menu') !== -1) {
      //       this.readOutLoud('Opening Menu');
      //       this.stop="drawer = !drawer"
      //       setTimeout(() => {
      //       window.scrollBy(0, -10000);
      //       }, 2200);
      } else if (msg.indexOf('scroll up') !== -1) {
            this.readOutLoud('Scrolling Up');
            setTimeout(() => {
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
            }, 2200);
      } else if (msg.indexOf('scroll down') !== -1) {
            this.readOutLoud('Scrolling Down');
            setTimeout(() => {
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
            }, 2200);
      } else if (msg.indexOf('scroll to top') !== -1) {
            this.readOutLoud('Scrolling to Top');
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
      } else if (msg.indexOf('scroll to bottom') !== -1) {
            this.readOutLoud('Scrolling to Bottom');
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
      // } else if (msg.indexOf('open') !== -1) {
      //       this.readOutLoud('Opening ' + msg.replace('open', '') + '');
      //       setTimeout(() => {
      //       new Audio(startAudioBrowser).play();
      //       window.open('https://' + msg.replace('open', '') + '', '_blank');
      //       }, 1900);
      } else if (msg.indexOf('i want to know about') !== -1) {
            this.p = document.createElement("p");
            this.readOutLoud('I found this for you and taking to you to ' + msg.replace('i want to know about', '') + '');
            // this.textArray.push(
            //     "repl." +
            //         "I found this for you and taking to you to " +
            //         "'" +
            //         msg +
            //         "'..."
            // );
            // let windows = "https://en.wikipedia.org/w/index.php?search=" + msg.replace('i want to know about', '');
            // this.iframe = document.createElement("iframe");
            // this.textArray.push(windows);
            // localStorage.setItem(
            //     "null",
            //     JSON.stringify(this.textArray)
            // );
            // let iframe = document.createElement("iframe");
            // iframe.src = this.text;
            // this.texts.appendChild(this.p);
            // this.texts.appendChild(this.iframe);
      // } else if (msg.indexOf('i want to know about') !== -1) {
      //   this.readOutLoud('Initiating general search for ' + msg.replace('i want to know about', '') + '');
      //   setTimeout(() => {
      //   new Audio(startAudioBrowser).play();

      //   window.open('https://en.wikipedia.org/w/index.php?search=' + msg.replace('i want to know about', ''), '_blank');
      //   }, 1500);
      } else if (msg.indexOf('go to') !== -1) {
        window.open('https://www.' + msg.replace('go to', ''), '_blank');
      } else if (msg.indexOf('open offerup') !== -1) {
        window.open('https://' + msg.replace('open offerup', 'offerup.com/'), '_blank');
      } else if (msg.indexOf('open gmail') !== -1) {
        window.open('https://' + msg.replace('open gmail', 'mail.google.com/mail/u/0/#inbox'), '_blank');
      } else if (msg.indexOf('open calendar') !== -1) {
        window.open('https://' + msg.replace('open calendar', 'calendar.google.com/calendar/'), '_blank');
      } else if (msg.indexOf('open google drive') !== -1) {
        window.open('https://' + msg.replace('open google drive', 'google.com/drive/'), '_blank');
      } else if (msg.indexOf('open trading') !== -1) {
        window.open('https://' + msg.replace('open trading', 'mintable.app/profile/my-wallet/'), '_blank');
      } else if (msg.indexOf('open photos') !== -1) {
        window.open('https://photos.google.com/?pli=1', '_blank');
      } else if (msg.indexOf('open github') !== -1) {
        window.open('https://github.com/', '_blank');
      } else if (msg.indexOf('lights turned on') !== -1 || msg.indexOf('turn lights on') !== -1 || msg.indexOf('lights on') !== -1 || msg.indexOf('turn on lights') !== -1 || msg.indexOf('lights enabled') !== -1 || msg.indexOf('activate lights') != -1) {
        new Audio(startAudioLight).play();
        this.readOutLoud('Lights on');
        window.fetch('https://maker.ifttt.com/trigger/on_lights/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights turned off') !== -1 || msg.indexOf('turn lights off') !== -1 || msg.indexOf('lights off') !== -1 || msg.indexOf('turn off lights') !== -1  || msg.indexOf('lights disabled') !== -1 || msg.indexOf('deactivate lights') != -1) {
        new Audio(startAudioLightsOff).play();
        this.readOutLoud('Lights off');
        window.fetch('https://maker.ifttt.com/trigger/lights_off/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('glide on') !== -1) {
        new Audio(startAudioBrightOn).play();
        this.readOutLoud('Govee Lights on');
        window.fetch('https://maker.ifttt.com/trigger/govee_on/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('glide off') !== -1) {
        new Audio(startAudioBrightOff).play();
        this.readOutLoud('Govee Lights off');
        window.fetch('https://maker.ifttt.com/trigger/govee_off/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights white') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to white');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_white/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights blue') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to blue');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_blue/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights red') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to red');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_red/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights night mode') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to night mode');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_night/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 20') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to twenty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_twenty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 40') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to forty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_forty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 60') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to sixty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_sixty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 80') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to eighty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_eighty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 100') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to one hundred percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_one_hundred/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('open stock tech') !== -1) {
        window.open('https://stocktech.ai/', '_blank');
      } else if (msg.indexOf('open erp') !== -1) {
        window.open('https://us.erp.gold/', '_blank');
      } else if (msg.indexOf('open zoho') !== -1) {
        window.open('https://zoho.com/', '_blank');
      } else if (msg.indexOf('open phone check') !== -1) {
        window.open('https:// cloudportal.phonecheck.com/cloud/Login', '_blank');
      } else if (msg.indexOf('open ebay') !== -1) {
        window.open('https://ebay.com/', '_blank');
      } else if (msg.indexOf('open gazelle') !== -1) {
        window.open('https://gazelle.com/', '_blank');
      } else if (msg.indexOf('open amazon') !== -1) {
        this.readOutLoud('Opening Amazon');
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://amazon.com/', '_blank');
        }, 2000);
      } else if (msg.indexOf('open my business') !== -1) {
        window.open('https://google.com/business/business-profile/', '_blank');
      } else if (msg.indexOf('open codex') !== -1) {
        window.open('https://beta.openai.com/codex-javascript-sandbox', '_blank');
      } else if (msg.indexOf('open time logix') !== -1) {
        window.open('https://time-logix.net', '_blank');
      } else if (msg.indexOf('open facebook') !== -1) {
        window.open('https://facebook.com/', '_blank');
      } else if (msg.indexOf('open instagram') !== -1) {
        window.open('https://instagram.com/', '_blank');
      } else if (msg.indexOf('open youtube') !== -1) {
        window.open('https://youtube.com/', '_blank');
      } else if (msg.indexOf('open netflix') !== -1) {
        this.readOutLoud('Opening Netflix');
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://netflix.com/', '_blank');
        }, 2000);
      } else if (msg.indexOf('help me') != -1 || msg.indexOf('help') != -1 || msg.indexOf('Help') != -1 || msg.indexOf('what can you do') != -1 || msg.indexOf('what can you do for me') != -1) {
        this.readOutLoud(`Surely I can help you but first you have to understand my protocols and commands. But you can have a good chat with me. Let's know the commands I can perform.`);
        new Audio(startAudioChange).play();
      } else if (msg.indexOf('open title') !== -1) {
                this.readOutLoud('Opening Tidal');
        setTimeout(() => {
        new Audio(startAudioChange).play();
        window.open('https://tidal.com/', '_blank');
        }, 1500);
      // } else if (msg.indexOf('open out look') !== -1) {
      //   window.open('C:/Program Files/Microsoft Office/root/Office16/OUTLOOK.exe');
      } else if (msg.indexOf('order food') !== -1) {
        window.open('https://food.google.com/', '_blank');
      } else if (msg.indexOf('open project') !== -1) {
        window.open('https://' + 'macheenist.atlassian.net/jira/software/projects/CF/boards/2', '_blank');
      } else if (msg.indexOf('initiate price research') !== -1) {
        window.open('https://buybackandrepair.com/', '_blank');
      } else if (msg.indexOf('initiate erp systems') !== -1) {
        window.open(
          'http://' + msg.replace('initiate erp systems', 'localhost:8080/leads'),
          '_blank',

          window.open('https://' + msg.replace('initiate erp systems', 'erp.gold/'), '_blank'),

          window.open('https://' + msg.replace('initiate erp systems', 'zoho.com/crm/?zmc=zoho-fa&ireft=ohome'), '_blank')
        );
        } else if (msg.indexOf("download pitch deck") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download pitch deck", "drive.google.com/file/d/11GTpUSHqM47dPZOGff3EbPnqnAaVfuJx/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download snap shot") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
        window.open(
              "https://" + msg.replace("download snap shot", "drive.google.com/file/d/11tWqUsTGdIINCrTl0O-LOhwNVr88vjmB/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download patent") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download patent", "drive.google.com/file/d/1TH0O0DeKIfEriUWncjZ4BHPi9cTEur5l/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download strategy") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download strategy", "drive.google.com/file/d/1kul9apTx7v8IgGwufwgS_2_RcPqEhW4E/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download lean canvas") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download lean canvas", "drive.google.com/file/d/13qR2d0hFrUOQ0VFBU3PFjcK4kQkaa4WT/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download analysis") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download analysis", "drive.google.com/file/d/1823Rj6hoRk8hZAT17OWpcHm_mK_Onq8K/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (
            msg.indexOf("download founder legal") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "http://" + msg.replace("download founder legal", "drive.google.com/file/d/1fgCAkfVSYcbn24iDm8S2235d7fF7YAdt/view?usp=sharing"),
              "_blank",

            window.open("https://" + msg.replace("download founder legal", "drive.google.com/file/d/1AQy_vxNAlxfsq-vN81yzuiPt_K5KObBB/view?usp=sharing"),
              "_blank"
            ),

            window.open("https://" + msg.replace("download founder legal", "drive.google.com/file/d/1nZcBNeJqXTxwhxRYvLBqNdWnTeP-Uzk_/view?usp=sharing"),
              "_blank"
            ),

        );
        }, 1500);
        } else if (
            msg.indexOf("download co-founder legal") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "http://" + msg.replace("download co-founder legal", "drive.google.com/file/d/1Paq_w3OfAas0uh81-QhkWYaviBX0k99K/view?usp=sharing"),
              "_blank",

            window.open("https://" + msg.replace("download co-founder legal", "drive.google.com/file/d/1FIb2jxplHJspQonSz3G5KZQ_-WhmAcV7/view?usp=sharing"),
              "_blank"
            ),

            window.open("https://" + msg.replace("download co-founder legal", "drive.google.com/file/d/1KFrk_qm9B1cLvCvyz5qWmk6kIReuG5oK/view?usp=sharing"),
              "_blank"
            ),

        );
        }, 1500);
        } else if (msg.indexOf("download pricing") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download pricing", "drive.google.com/file/d/1_tfYsyz2je8YsVOBGDWTb3UuK5aXq75N/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download brand guidelines") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download brand guidelines", "drive.google.com/drive/folders/14YsvFIvVCI6TUyfFt5r5Gcp8xU0iOUOK?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download projections") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download projections", "drive.google.com/file/d/1g9DAahrZGeSwON3c_b0NtkM_r6UfV_Wd/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download sales process") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download sales process", "drive.google.com/file/d/192kKN_eCA6qa6kjD8dgvxn8KM_Q19OuD/view?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download diagrams") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download diagrams", "drive.google.com/drive/folders/1NYadG7MVozCxaRYCQMpjiT3sCecwNzND?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download research") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download research", "drive.google.com/drive/folders/1rkCz3UqNcs98qcNXmh5J3RQR-NtCDbV8?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download screenshots") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download screenshots", "drive.google.com/drive/folders/1pf2IkLwmhY5nSmY7m7I84YRZekLw23yo?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download drawings") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download drawings", "drive.google.com/drive/folders/18mFhnwh0qbuPK95u-nSx1-M3mHIVgvC3?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("download backlog") !== -1) {
        this.readOutLoud('Commencing to' + msg + '.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("download backlog", "drive.google.com/drive/folders/1VRw3sA6qMDoLDSHMO4S3elQmExBqHtS7?usp=sharing"),
              "_blank"
            );
        }, 1500);
        } else if (msg.indexOf("request access") !== -1) {
        this.readOutLoud('Initiating your' + msg + 'to your Data Room Vault.......');
        setTimeout(() => {
        new Audio(startAudioDownload).play();
            window.open(
              "https://" + msg.replace("request access", "drive.google.com/drive/folders/19El57V_UTV1NkzfDESLSO4ZVpD0FVhv2?usp=sharing"),
              "_blank"
            );
          }, 1500);
      } else if (msg.indexOf('create') != -1) {
        this.requestType = 'startForm';

        if (msg.indexOf('lead') != -1) {
          if (this.$route.path !== '/leads') {
            this.$router.push({ name: 'Leads' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('purchase order') != -1 || msg.indexOf('purchaseorder') != -1) {
          if (this.$route.path !== '/purchaseorders') {
            this.$router.push({ name: 'PurchaseOrders' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        }  else if (msg.indexOf('notes') != -1 || msg.indexOf('note') != -1) {
          if (this.$route.path !== '/googlevoicesearch') {
            this.$router.push({ name: 'GoogleVoiceSearch' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('inventory') != -1) {
          if (this.$route.path !== '/inventory') {
            this.$router.push({ name: 'Inventory' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('repair') != -1) {
          if (this.$route.path !== '/repairs') {
            this.$router.push({ name: 'Repairs' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('fulfillment') != -1) {
          if (this.$route.path !== '/fulfillments') {
            this.$router.push({ name: 'Fulfillments' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('task') != -1) {
          if (this.$route.path !== '/tasks') {
            this.$router.push({ name: 'Tasks' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('productmatrix') != -1) {
          if (this.$route.path !== '/productmatrix') {
            this.$router.push({ name: 'ProductMatrix' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('contact') != -1) {
          if (this.$route.path !== '/contacts') {
            this.$router.push({ name: 'Contacts' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('account') != -1) {
          if (this.$route.path !== '/accounts') {
            this.$router.push({ name: 'Accounts' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('vendor') != -1) {
          if (this.$route.path !== '/vendors') {
            this.$router.push({ name: 'Vendors' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('buyback') != -1) {
          if (this.$route.path !== '/buybackorders') {
            this.$router.push({ name: 'BuybackOrders' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('quote') != -1) {
          if (this.$route.path !== '/quotes') {
            this.$router.push({ name: 'Quotes' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('invoice') != -1) {
          if (this.$route.path !== '/invoices') {
            this.$router.push({ name: 'Invoices' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        }
      } else if (msg.indexOf('edit') != -1 || msg.indexOf('update') != -1) {
        this.requestType = 'editForm';
        Event.$emit('editFromRecord', { msg });
      } else if (msg.indexOf('computer') != -1) {        
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        let index = msg.indexOf('computer');

        msg = msg.slice(index + 9);
        if (msg == '') return;
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await response.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });   
        this.readOutLoud(message);

        setTimeout(() => {
        this.overlay = false;
        }, 14000);
      } else if (msg.toLowerCase().indexOf('generate image') != -1) {
  // this.showVoice = true;
  // this.overlay = true;

  setTimeout(() => {
        new Audio(startAudioVisual).play();
    }, 500);

    // Navigate to the image generation page ("/canvas")
    this.$router.push('/canvas'); // Assuming Vue Router is being used

    // Wait for 3 seconds then ask the user what they want to create
    setTimeout(() => {
        this.startRecording(); // This function needs to be defined or imported
    }, 3000);

  // Navigate to /canvas page (assuming you have Vue Router set up)
  this.$router.push('/canvas').then(() => {
    // Wait for the page to load
    setTimeout(async () => {
      // Access the canvas component's methods
      if (this.$refs.canvasComponent) {
        // Start Recording
        this.$refs.startRecording();

        // Listen for the end of the recording
        const checkIfRecordingStopped = setInterval(() => {
          if (!this.$refs.canvasComponent.isRecording) {
            clearInterval(checkIfRecordingStopped);

            // Wait 3 seconds after the recording stops
            setTimeout(() => {
              // Submit the generate image prompt
              this.$refs.canvasComponent.generateImage();
            }, 3000);
          }
        }, 1000);
      }
    }, 2500);
  });

  setTimeout(() => {
    this.overlay = false;
  }, 14000);
} else if (msg.toLowerCase().indexOf('start order') != -1 || msg.toLowerCase().indexOf('place order') != -1) {

  setTimeout(() => {
        new Audio(startAudioVisual).play();
    }, 500);

    // Navigate to the image generation page ("/canvas")
    this.$router.push('/posdemo'); // Assuming Vue Router is being used

    // Wait for 3 seconds then ask the user what they want to create
    setTimeout(() => {
        this.startRecording(); // This function needs to be defined or imported
    }, 3000);

  // Navigate to /canvas page (assuming you have Vue Router set up)
  this.$router.push('/posdemo').then(() => {
    // Wait for the page to load
    setTimeout(async () => {
      // Access the canvas component's methods
      if (this.$refs.canvasComponent) {
        // Start Recording
        this.$refs.startRecording();

        // Listen for the end of the recording
        const checkIfRecordingStopped = setInterval(() => {
          if (!this.$refs.canvasComponent.isRecording) {
            clearInterval(checkIfRecordingStopped);
          }
        }, 1000);
      }
    }, 2500);
  });

  setTimeout(() => {
    this.overlay = false;
  }, 14000);

} else if (msg.toLowerCase().indexOf('access knowledge bank') != -1) {
  // this.showVoice = true;
  // this.overlay = true;

  setTimeout(() => {
        new Audio(startAudioVisual).play();
    }, 500);

    // Navigate to the image generation page ("/canvas")
    this.$router.push('/brain'); // Assuming Vue Router is being used

    // Wait for 3 seconds then ask the user what they want to create
    setTimeout(() => {
        this.startRecording(); // This function needs to be defined or imported
    }, 3000);

  // Navigate to /canvas page (assuming you have Vue Router set up)
  this.$router.push('/brain').then(() => {
    // Wait for the page to load
    setTimeout(async () => {
      // Access the canvas component's methods
      if (this.$refs.canvasComponent) {
        // Start Recording
        this.$refs.startRecording();

        // Listen for the end of the recording
        const checkIfRecordingStopped = setInterval(() => {
          if (!this.$refs.canvasComponent.isRecording) {
            clearInterval(checkIfRecordingStopped);

            // Wait 3 seconds after the recording stops
            setTimeout(() => {
              // Submit the generate image prompt
              this.$refs.canvasComponent.generateImage();
            }, 3000);
          }
        }, 1000);
      }
    }, 2500);
  });

  setTimeout(() => {
    this.overlay = false;
  }, 14000);
  } else if (msg.indexOf('codex') != -1) {
  let index = msg.indexOf('codex');
  this.showVoice = true;
  this.overlay = true;

  setTimeout(() => {
    new Audio(startAudioVisual).play();
  }, 500);

  if (this.$route.path !== '/cogassistant') {
    this.$router.push({ name: 'CogAssitant' });
    this.requestType = '';
    msg = msg.slice(index + 9);
    if (msg == '') return;
  }

  const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message: msg }),
  });
  const content = await rawResponse.json();
  let message = content.message.replace(/AI/g, '');
  message = message.replace(/:/g, '');
  this.$store.commit('updateMessage', { message });
  this.readOutLoud('Generated AI: ' + message);
  setTimeout(() => {
    this.overlay = false;
  }, 12000);
  // setTimeout(() => {
  // // Generate AI code and add it to the codeEditor
  // this.codeEditor.insert(message);

  // // Update the outputIframe with the new code
  // document.getElementById("outputIframe").srcdoc = this.codeEditor.getValue();

  // // Create typing animation and play sound effects
  // const typingAnimation = setInterval(() => {
  //   new Audio(typingAudio).play();
  // }, 150);

  // setTimeout(() => {
  //   clearInterval(typingAnimation);
  //   new Audio(completeAudio).play();
  // }, message.length * 150);
  // }, 5000);
} else if (msg.indexOf('concierge') != -1) {
  let index = msg.indexOf('concierge');

  this.showVoice = true;
  this.overlay = true;

  setTimeout(() => {
    new Audio(startAudioVisual).play();
  }, 500);
  if (this.$route.path !== '/cogassistant') {
    this.$router.push({ name: 'CogAssitant' });

    this.requestType = '';
    msg = msg.slice(index + 9);
    if (msg == '') return;
  }
  const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message: msg }),
  });
  const content = await rawResponse.json();
  let message = content.message.replace(/AI/g, '');
  message = message.replace(/:/g, '');
  this.$store.commit('updateMessage', { message });
  this.readOutLoud('Generated AI: ' + message);

  // Set the queryPrompt and call submitQuery() with the returned message
  this.queryPrompt = message;
  this.submitQuery();

  setTimeout(() => {
    this.overlay = false;
  }, 12000);
      } else if (msg.indexOf('creative') != -1) {
        let index = msg.indexOf('creative');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        if (this.$route.path !== '/creator') {
        this.$router.push({ name: 'Creator' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence2`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Creative: ' + message);

        setTimeout(() => {
          this.overlay = false;
        }, 14000);
      } else if (msg.indexOf('program') != -1) {
        let index = msg.indexOf('program');
        if (this.$route.path !== '/program') {
        this.$router.push({ name: 'Program' });
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-codex`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Generated Program: ' + message);
        
        setTimeout(() => {
          this.overlay = false;
        }, 14000);
      } else if (msg.indexOf('research') != -1) {
        let index = msg.indexOf('research');
        this.showVoice = true;
        this.overlay = true;
        
        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        if (this.$route.path !== '/researchassistant') {
        this.$router.push({ name: 'ResearchAssistant' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }

        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Commencing research for ' + msg + '.......' + '' + message);
        setTimeout(() => {
          this.overlay = false;
        }, 18000);
        setTimeout(() => {
          window.open('https://www.google.com/search?q=' + msg.replace('research', ''), '_blank');
          // window.open('https://en.wikipedia.org/wiki/search?q=' + msg.replace('research', ''), '_blank');
        }, 24000);
        } else if (msg.indexOf('assistant') != -1) {
        let index = msg.indexOf('assistant');
        this.showVoice = true;
        this.overlay = true;
        
        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        if (this.$route.path !== '/intel') {
        this.$router.push({ name: 'Intel' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Generated Research: ' + message);
        setTimeout(() => {
        this.overlay = false;
        }, 12000);
      } else if (msg.indexOf('ideation') != -1) {
        let index = msg.indexOf('Ideation');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        if (this.$route.path !== '/creator') {
        this.$router.push({ name: 'Creator' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence4`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Ideation: ' + message);
        setTimeout(() => {
          this.overlay = false;
        }, 8000);
      } else if (msg.indexOf('device detail') != -1 || msg.indexOf('device details') != -1) {
        if (this.$route.path !== '/imei') {
          this.$router.push({ name: 'IMEI' });
          this.readOutLoud('Please tell me the IMEI number');
        } else {
          this.readOutLoud('Please tell me the IMEI number');
        }
      } else if (msg.indexOf('initiate search') != -1) {
        this.requestType = 'search';
        this.readOutLoud('Search initiated, what would you like to search');
        return;
      } else if (msg.indexOf('compose email') !== -1) {
        this.showEmail = true;
      } else if (msg.indexOf('generate invoice') != -1) {
        Event.$emit('generateInvoice', { msg });
        return;
      } else if (msg.indexOf('generate purchase order') != -1) {
        Event.$emit('generatePurchaseOrder', { msg });
        return;
      } else if (msg.indexOf('generate quote') != -1) {
        Event.$emit('generateQuote', { msg });
        return;
      } else if (msg.indexOf('show commands') != -1) {
        Event.$emit('showCommands', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('start introduction') != -1) {
        Event.$emit('playIntroduction', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('start training') != -1) {
        Event.$emit('startTraining', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show calendar') != -1) {
        Event.$emit('showCard', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show dialog') != -1) {
        Event.$emit('showDialog', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show email') != -1) {
        Event.$emit('showEmail', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show apple') != -1) {
        Event.$emit('showApple', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show samsung') != -1) {
        Event.$emit('showSamsung', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('video chat') != -1) {
        Event.$emit('showVideo', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('screen share') != -1) {
        Event.$emit('showShare', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play mix') != -1) {
        Event.$emit('playMix', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play night') != -1) {
        Event.$emit('playNight', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play tech') != -1) {
        Event.$emit('playTech', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play chill') != -1) {
        Event.$emit('playChill', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play smooth') != -1) {
        Event.$emit('playSmooth', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play cyber') != -1) {
        Event.$emit('playCyber', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play rap') != -1) {
        Event.$emit('playRap', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play hits') != -1) {
        Event.$emit('playHits', { msg }); // This will trigger to open the card
        new Audio(startAudioChange).play();
        return;
      } else if (msg.indexOf('play urban') != -1) {
        Event.$emit('playUrban', { msg }); // This will trigger to open the card
        new Audio(startAudioChange).play();
        return;
      } else if (msg.indexOf('play jazz') != -1) {
        Event.$emit('playJazz', { msg }); // This will trigger to open the card
        new Audio(startAudioChange).play();
        return;
      } else if (msg.indexOf('close') != -1) {
        Event.$emit('closeCard', { msg }); // This will trigger to open the card
        new Audio(startAudioClose).play();
        return;
      } else if (msg.indexOf('stop listening') != -1 || msg.indexOf('stop') != -1) {
        Event.$emit('closeCard', { msg }); // This will trigger to open the card
        new Audio(startAudioClose).play();
        return;
      } else if (msg.indexOf('locate') !== -1) {
        //  Using "locate" word for google map navigation content
        if (this.$route.path !== '/map') {
          this.$router.push({ name: 'Map' });
          setTimeout(() => {
            Event.$emit('locate', { msg });
          }, 500);
        } else {
          Event.$emit('locate', { msg });
        }
      } else if (msg.indexOf('call') !== -1) {
        if (this.$route.path !== '/videocall') {
          this.$router.push({ name: 'VideoCall' });
          setTimeout(() => {
            Event.$emit('new_room', 'Cogneetiv_Group');
          }, 500);
        } else {
          Event.$emit('new_room', 'Cogneetiv_Group');
        }
      } else if (msg.indexOf('briefing') !== -1) {
        if (this.$route.path !== '/dailybriefing') {
          this.$router.push({ name: 'DailyBriefing' });
          this.requestType = '';
          return;
        } else {
          Event.$emit('startbriefing', { msg });
        }
      } else if (msg.indexOf('report') !== -1) {
        if (this.$route.path !== '/analytics') {
          this.$router.push({ name: 'Analytics' });
          setTimeout(() => {
            Event.$emit('graphs', msg);
          }, 500);
        } else {
          Event.$emit('graphs', msg);
        }
      } else {
        if (msg == '') return;

        const rawResponse = await fetch(process.env.VUE_APP_AI_SERVER, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        console.log(content[0]);
        if (content[0].custom) {
          switch (content[0].custom.type) {
            case 'text':
              this.readOutLoud(content[0].custom.data);
              break;
            case 'graph':
              if (this.$route.path !== '/analytics') {
                this.$router.push({ name: 'Analytics' });
                setTimeout(() => {
                  Event.$emit('graphs', content[0].custom);
                }, 500);
              } else {
                Event.$emit('graphs', content[0].custom);
              }
              break;
            default:
              this.readOutLoud(content[0].text);
              break;
          }
        } else {
          this.readOutLoud(content[0].text);
        }
      }
    },
  },
computed: {},
mounted: function () {

  this.initSpeechSynthesis();
    
let texts = document.querySelector(".texts"); // Get the element.

// If localStorage has 'CogneetivAIChat0416v3' item, get it. Or set the array to CogneetivAIChat0416v3.
let textArray = localStorage.getItem("CogneetivAIChat0416v3")
    ? JSON.parse(localStorage.getItem("CogneetivAIChat0416v3"))
    : [];
if (!localStorage.getItem("CogneetivAIChat0416v3")) {
    // Setting Item to local storage.
    localStorage.setItem(
        "CogneetivAIChat0416v3",
        JSON.stringify(textArray)
    );
}

// Loading previous Chats.
class PastChat {
    constructor(text) {
        this.text = text;
        if (this.text.includes("repl.")) {
            this.text = this.text.replace("repl.", "");
            this.reply();
        } else if (
            text.includes("https://en.wikipedia.org/w/index.php?search=") ||
            text.includes("https://www.bing.com/search?q=") ||
            text.includes("https://www.bing.com/images/search?q=") ||
            text.includes("https://www.google.com/search?q=") ||
            text.includes("https://www.google.com/search?tbm=isch&q=") ||
            text.includes("https://www.bing.com/videos/search?q=")
        ) {
            this.panel();
        } else {
            this.comment();
        }
    }
    // The comment generator function
    comment() {
        let p = document.createElement("p");
        p.innerText = this.text;
        texts.appendChild(p);
    }
    // The reply generator function
    reply() {
        let p = document.createElement("p");
        p.classList.add("reply");
        p.innerText = this.text;
        texts.appendChild(p);
    }
    // The iframe generator function
    panel() {
        let iframe = document.createElement("iframe");
        iframe.src = this.text;
        texts.appendChild(iframe);
    }
}

// For each text in the textArray...
for (let i = 0; i < textArray.length; i++) {
    const text = textArray[i];
    new PastChat(text, this.msg);
}

let p = document.createElement("p");
this.recognition.addEventListener("result", (e) => {
    texts.appendChild(p);
    let text = Array.from(e.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");

    p.textContent = text;
    if (e.results[0].isFinal) {
        textArray.push(text); // Push the text to the text array.
        localStorage.setItem(
            "CogneetivAIChat0416v3",
            JSON.stringify(textArray) // Stringify the text array
        );

        // All the possible condition.
        if (text.includes("How are you")) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.innerText = "I am fine";
            texts.appendChild(p);
            textArray.push("repl.I am fine");
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
        } else if (text.includes("Hello") || text.includes("Hii")) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.innerText = "Hi, there!";

            textArray.push("repl." + "Hey! How are you?");
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            texts.appendChild(p);
        } else if (
            text.includes("What is your name") ||
            text.includes("What's your name")
        ) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.textContent = "My name is Bro";
            texts.appendChild(p);
            textArray.push("repl.My name is Bro");
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
        } else if (
            text.includes("Cognitive, I need your help.") ||
            text.includes("cognitive, activate system.") 
        ) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.textContent = "How can I be of help?";
            texts.appendChild(p);
            this.readOutLoud("How can I be of help?");
            textArray.push("repl.How can I be of help?");
            this.document.getElementById("start-animate").click();  
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
        } else if (text.includes("Thank")) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.textContent = "Your Welcome.";
            texts.appendChild(p);
            textArray.push("repl.Your Welcome");
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
        } else if (text.includes("Delete conversation")) {
            p = document.querySelectorAll("p");
            let iframe = document.querySelectorAll("iframe");
            textArray = [];
            localStorage.setItem("CogneetivAIChat0416v3", [
                JSON.stringify(textArray)
            ]);
            iframe.forEach((frame) => {
                frame.remove();
            });
            p.forEach((para) => {
                para.remove();
            });
        } else if (text.includes("Search")) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.textContent = text.replace("Search", "Searching");
            textArray.push("repl.Searching" + text.replace("search", ""));
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            text = text.replace(" ", "?q=");
            texts.appendChild(p);
            window.open("https://google.com/" + text);
        // } else if (text.includes("youtube")) {
        //   setTimeout(() => {
        //     p = document.createElement("p");
        //     p.classList.add("reply");
        //     textArray.push("repl.Searching" + text.replace("youtube", ""));
        //     localStorage.setItem(
        //         "CogneetivAIChat0416v3",
        //         JSON.stringify(textArray)
        //     );
        //     p.textContent = text.replace("youtube", "Searching");
        //     text = text.replace(" ", "=");
        //     texts.appendChild(p);
        //     text = text.replace("youtube", "");
        //     window.open("https://www.youtube.com/results?search_query" + text);
        //   }, 2000);
        } else if (text.includes("YouTube")) {
                    setTimeout(() => {
            new Audio(startAudioResearch).play();
            p = document.createElement("p");
            p.classList.add("reply");
            text = text.replace("YouTube", "");
            p.textContent = "Initiating Youtube Search for " + text;
            let windows = "https://www.youtube.com/results?search_query" + text;
            let iframe = document.createElement("iframe");

            textArray.push("repl." + this.p.textContent);
            textArray.push(windows);
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            iframe.src = windows;
            texts.appendChild(p);
            texts.appendChild(iframe);
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
          }, 3000);
        // } else if (text.includes("youtube")) {
        //   setTimeout(() => {
        //     p = document.createElement("p");
        //     p.classList.add("reply");
        //     textArray.push("repl.Searching" + text.replace("youtube", ""));
        //     localStorage.setItem(
        //         "CogneetivAIChat0416v3",
        //         JSON.stringify(textArray)
        //     );
        //     p.textContent = text.replace("youtube", "Searching");
        //     text = text.replace(" ", "=");
        //     texts.appendChild(p);
        //     text = text.replace("youtube", "");
        //     window.open("https://www.youtube.com/results?search_query" + text);
        //   }, 2000);
        } else if (text.includes("help me") || text.includes("help") || text.includes("Help") || text.includes("what can you do") || text.includes("What can you do for me")) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.innerHTML = `
            <ul>
                <li>Speak <b>Delete conversation</b> to clear the screen including all the conversions.</li>
                <li>Speak <b>Search</b> to search anything.</li>
                <li>Speak <b>YouTube</b> to search in <a href="https://www.youtube.com">YouTube</a>.</li>
                <li>Speak <b>Website</b> to go to a commercial website. <strong>Note: </strong> Website must be valid.</li>
                <li>Speak <b>I want to know about</b> to search your question in Wikipedia.</li>
                <li>Speak <b>'Time' or 'date'</b> to know time.</li>
            </ul>`;
            textArray.push("repl." + p.innerHTML);
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            texts.appendChild(p);
        } else if (text.includes("Website")) {
            p = document.createElement("p");
            p.classList.add("reply");
            text = text.replace("Website ", "");
            p.textContent = "Opening " + "'" + text + "'...";
            textArray.push("repl.Opening " + text + "...");
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            texts.appendChild(p);
            window.open("https://" + text + ".com/");

        } else if (
            text.includes("computer") 
        ) {
            p = document.createElement("p");
            p.classList.add("reply");
            p.textContent = store.state.message;
            textArray.push("repl." + this.p.textContent);
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            texts.appendChild(p); 

// } else if (text.includes("computer")) {
//   const msg = text.slice(text.indexOf("computer") + 9);

//   if (msg !== "") {
//     const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
//       method: 'POST',
//       headers: {
//         Accept: 'application/json',
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ message: msg }),
//     });

//     const content = await rawResponse.json();
//     let message = content.message.replace(/AI/g, '').replace(/:/g, '');

//     this.readOutLoud(message);

//     p = document.createElement("p");
//     p.classList.add("reply");
//     p.textContent = message;
//     textArray.push("repl." + p.textContent);
//     localStorage.setItem(
//       "CogneetivAIChat0416v3",
//       JSON.stringify(textArray)
//     );
//     texts.appendChild(p);
//   }
// }
// } else if (text.includes("Computer")) {

//   this.msg = text.slice(text.indexOf("computer") + 9);
//           // this.body: JSON.stringify({ message: msg }),
//     const content = this.rawResponse.json();
//     let message = content.message.replace(/AI/g, '');
//     this.$store.commit('updateMessage', { message });  
//     this.readOutLoud(message);

//     p = document.createElement("p");
//     p.classList.add("reply");
//     p.textContent = JSON.stringify({ message: this.msg });
//     textArray.push("repl." + p.textContent);
//     localStorage.setItem(
//       "CogneetivAIChat0416v3",
//       JSON.stringify(textArray)
//     );
//     texts.appendChild(p);
// }
      } else if (
            text.includes("Date") ||
            text.includes("Time") ||
            text.includes("date") ||
            text.includes("time")
        ) {
            p = document.createElement("p");
            p.classList.add("reply");
            const date = new Date();
            const options = { weekday: "long", month: "long", day: "numeric" };
            let day = date.toLocaleDateString("en-US", options);
            let time = date.toLocaleTimeString();
            p.textContent = this.readOutLoud('The current time is ' + time + ', and the date is ' + day);
            textArray.push("repl." + this.p.textContent);
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            texts.appendChild(p); 
// } else if (text.includes('')) {
//   setTimeout(() => {
//     p = document.createElement("p");
//     p.classList.add("reply");
//             let message = this.content.message.replace(/AI/g, '');
//         message = message.replace(/:/g, '');
//     this.$store.commit('updateMessage', { message });
//     p.textContent = this.readOutLoud(message);
//     textArray.push("repl." + this.p.textContent);

//     // p.textContent = "" + this.msg + "" + this.message;
//     // textArray.push("repl." + this.p.textContent);


//     localStorage.setItem(
//         "CogneetivAIChat0416v3",
//         JSON.stringify(textArray)
//     );

//     // Updating iframe source with the new code

//     texts.appendChild(p);
//     window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
//   }, 2000);
        } else if (text.includes("I want to know about")) {
            p = document.createElement("p");
            p.classList.add("reply");
            text = text.replace("I want to know about", "");
            p.textContent = "Searching Wikipedia for...." + text;
            let windows = "https://en.wikipedia.org/w/index.php?search=" + text;
            let iframe = document.createElement("iframe");
            textArray.push(windows);
            // On Progress
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            iframe.src = windows;
            texts.appendChild(p);
            texts.appendChild(iframe);
        } else if (text.includes("research")) {
          setTimeout(() => {
            new Audio(startAudioResearch).play();
            p = document.createElement("p");
            p.classList.add("reply");
            text = text.replace("research", "");
            p.textContent = "Searching online for more information on " + text;
            let windows = "https://en.wikipedia.org/w/index.php?search=" + text;
            let windows2 = "https://www.bing.com/search?q=" + text;
            let windows3 = "https://www.bing.com/images/search?q=" + text;
            let windows4 = "https://www.bing.com/videos/search?q=" + text;
            // let windows5 = "https://cse.google.com/cse?cx=87a5cd3086b3e4db7#gsc.tab=0&gsc.q=" + text;
            // let windows5 = "https://www.youtube.com/embed/" + text;
            let iframe = document.createElement("iframe");
            let iframe2 = document.createElement("iframe");
            let iframe3 = document.createElement("iframe");
            let iframe4 = document.createElement("iframe");
            // let iframe5 = document.createElement("iframe");

            textArray.push("repl." + this.p.textContent);
            textArray.push(windows);
            textArray.push(windows2);
            textArray.push(windows3);
            textArray.push(windows4);
            // textArray.push(windows5);
            // On Progress
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            iframe.src = windows;
            iframe2.src = windows2;
            iframe3.src = windows3;
            iframe4.src = windows4;
            // iframe5.src = windows5;
            texts.appendChild(p);
            texts.appendChild(iframe);
            texts.appendChild(iframe2);
            texts.appendChild(iframe3);
            texts.appendChild(iframe4);
            // texts.appendChild(iframe5);
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
          }, 24000);
        } else if (text.includes("search for")) {
          setTimeout(() => {
            new Audio(startAudioResearch).play();
            p = document.createElement("p");
            p.classList.add("reply");
            text = text.replace("search for", "");
            p.textContent = "Here are the online results for  " + text;
            let windows = "https://en.wikipedia.org/w/index.php?search=" + text;
            let windows2 = "https://www.bing.com/search?q=" + text;
            let windows3 = "https://www.bing.com/images/search?q=" + text;
            let windows4 = "https://www.bing.com/videos/search?q=" + text;
            // let windows5 = "https://cse.google.com/cse?cx=87a5cd3086b3e4db7#gsc.tab=0&gsc.q=" + text;
            // let windows5 = "https://www.youtube.com/embed/" + text;
            let iframe = document.createElement("iframe");
            let iframe2 = document.createElement("iframe");
            let iframe3 = document.createElement("iframe");
            let iframe4 = document.createElement("iframe");
            // let iframe5 = document.createElement("iframe");
            textArray.push("repl." + "Here are the online results for  " + text);
            textArray.push(windows);
            textArray.push(windows2);
            textArray.push(windows3);
            textArray.push(windows4);

            // textArray.push(windows5);
            // On Progress
            localStorage.setItem(
                "CogneetivAIChat0416v3",
                JSON.stringify(textArray)
            );
            iframe.src = windows;
            iframe2.src = windows2;
            iframe3.src = windows3;
            iframe4.src = windows4;
            // iframe5.src = windows5;
            texts.appendChild(p);
            texts.appendChild(iframe);
            texts.appendChild(iframe2);
            texts.appendChild(iframe3);
            texts.appendChild(iframe4);
            // texts.appendChild(iframe5);
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
          }, 3000);
        }
        this.speaker = window.speechSynthesis;
        this.speakFunction();

        p = document.createElement("p");
        // Else Will be coming soon...
        // else {
        //     p = document.createElement("p");
        //     p.classList.add("reply");
        //     p.textContent =
        //         "Sorry, I couldn't understand you. Please speak in English or say 'help' to know my commands. Thank you.";
        //     texts.appendChild(p);
        // }
        window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
    }
});

this.recognition.start();

    var childSpanClassAttr = this.$refs.wake.getAttribute ('class');
    
    console.log('<span> was declared with "class" attr -->', childSpanClassAttr);
    
      Event.$on('speakModeOn', () => {
        this.startSpeaking();
      });
  },
  beforeDestroy() {
    Event.$off('speakModeOn');
    Event.$off('openForm');
  },
  beforeMount() {
    this.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new window.webkitSpeechRecognition();
    const recognition = this.SpeechRecognition(); // Getting Speech Recognition api
    recognition.interimResults = true; // Browser corrects user's spelling mistakes and finalizes them.
    recognition.continuous = false; // Continuous listening
    recognition.lang = "en-US"; // Language
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");
@keyframes neon-loading {
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.5) rotate(180deg);
    opacity: 0.5;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
}
.neon-ring-container {
  position: relative;
  width: 300px;
  height: 100px;
}
.neon-ring {
  display: inline-block;
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: transparent;
  border: 3px solid #48a981;
  animation: neon-loading 1.5s infinite linear;
  animation-timeline: 3s;
  transform-origin: 50% 50%;
}

.neon-ring:nth-child(2) {
  width: 64px;
  height: 64px;
  border-color: #5a80bf;
  animation-delay: 0.2s;
}

.neon-ring:nth-child(3) {
  width: 48px;
  height: 48px;
  border-color: #d14f8c;
  animation-delay: 0.4s;
}

.neon-ring:nth-child(4) {
  width: 32px;
  height: 32px;
  border-color: #de8c4c;
  animation-delay: 0.6s;
}

.neon-ring:nth-child(5) {
  width: 16px;
  height: 16px;
  border-color: #ffffff;
  animation-delay: 0.8s;
}
.thinking-animation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.thinking-text {
  font-size: 24px;
  color: #48a981;
  margin-top: 10px;
  opacity: 0;
  transition: opacity 0.5s;
}

@keyframes colorful-animation {
  0% {
    background-color: #48a981;
  }
  25% {
    background-color: #5a80bf;
  }
  50% {
    background-color: #d14f8c;
  }
  75% {
    background-color: #de8c4c;
  }
  100% {
    background-color: #48a981;
  }
}

.colorful-animation {
  animation: colorful-animation 1s infinite;
  width: 400px;
  height: 100px;
  border-radius: 20px;
  margin-bottom: -50px;
  padding-block: 10px;
  padding-inline: 10px;
  align-items: center;
  justify-content: center;
  color: #000;
}

#start-animate.start-animate {
    animation: mic-animate 1.2s infinite alternate;
    border-radius: 60px;
    width: 60px;
    height: 60px;
  }
  
  @keyframes mic-animate {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.2);
      margin-top: -145px;
    }
  }
.load-wrapper{
  position: relative;
  height: 80px;
  width: 100%;
  background-color: rgba(23, 23, 51, 0.2);
  z-index: 1;
  overflow: hidden;
}
/* .activity{
  position: absolute;
  left: -45%;
  height: 50px;
  width: 50%;
  background-image: linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05));
  background-image: -moz-linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05));
  background-image: -webkit-linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05));
  animation: loading 1s infinite;
  z-index: 45;
}

@keyframes loading {
  0%{
    left: -45%;
  }
  100%{
    left: 100%;
  }
} */
.uicontainer {
    position: relative;
    margin-block: -30px;
    background: #78b59c;

}

.chatBoxAI {
    background-color: #5a80bf;
    filter: progid: DXImageTransform.Microsoft.gradient(gradientType=1, startColorstr='#48a981', endColorstr='#2f9269');
    background-image: url(//img.alicdn.com/tps/TB1d.u8MXXXXXXuXFXXXXXXXXXX-1900-790.jpg);
    background-size: 100%;
    background-image: -webkit-gradient(linear, 0 0, 100% 100%, color-stop(0, #48a981), color-stop(100%, #2f9269));
    background-image: -webkit-linear-gradient(135deg, #48a981, #2f9269);
    background-image: -moz-linear-gradient(45deg, #48a981, #2f9269);
    background-image: -ms-linear-gradient(45deg, #48a981 0, #2f9269 100%);
    background-image: -o-linear-gradient(45deg, #48a981, #2f9269);
    background-image: linear-gradient(135deg, #48a981, #2f9269);
    padding-block: 50px;
    margin-left: 5%;
    position: sticky;
    padding: 50px 50px;
    border-radius: 20px;
    text-align: left;
    width: 90%;
    transform: translateY(1px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
@keyframes writing {
    0% { content: '   '; }
    25% { content: '•  '; }
    50% { content: '•• '; }
    75% { content: '•••'; }
    100% { content: '   '; }
  }
  
  @keyframes fadein {
    0% {
      opacity: 0;
      transform: scale(0);
      filter: blur(8px);
    }
    100% {
      opacity: 1;
      transform: scale(1.0);
      filter: blur(0px);
    }
  }

.chatBoxAI {
    background-color: #5a80bf;
    filter: progid: DXImageTransform.Microsoft.gradient(gradientType=1, startColorstr='#48a981', endColorstr='#2f9269');
    background-image: url(//img.alicdn.com/tps/TB1d.u8MXXXXXXuXFXXXXXXXXXX-1900-790.jpg);
    background-size: 100%;
    background-image: -webkit-gradient(linear, 0 0, 100% 100%, color-stop(0, #48a981), color-stop(100%, #2f9269));
    background-image: -webkit-linear-gradient(135deg, #48a981, #2f9269);
    background-image: -moz-linear-gradient(45deg, #48a981, #2f9269);
    background-image: -ms-linear-gradient(45deg, #48a981 0, #2f9269 100%);
    background-image: -o-linear-gradient(45deg, #48a981, #2f9269);
    background-image: linear-gradient(135deg, #48a981, #2f9269);
    padding-block: 50px;
    margin-left: 5%;
    position: sticky;
    padding: 50px 50px;
    border-radius: 20px;
    text-align: left;
    width: 90%;
    transform: translateY(1px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
@keyframes writing {
    0% { content: '   '; }
    25% { content: '•  '; }
    50% { content: '•• '; }
    75% { content: '•••'; }
    100% { content: '   '; }
  }
  
  @keyframes fadein {
    0% {
      opacity: 0;
      transform: scale(0);
      filter: blur(8px);
    }
    100% {
      opacity: 1;
      transform: scale(1.0);
      filter: blur(0px);
    }
  }
  
  .video-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); 
  z-index: 9999; 
}
.video-overlay button {
    position: absolute;
    width: 150px;
    top: 10px;
    right: 10px;
    background-color: rgba(18, 12, 20, 0.532);
    color: #fff;
    border: none;
    border-radius: 20px;
    padding: 5px 10px;
    margin-block: 10px;
    cursor: pointer;
}

.chatBox {
    padding-block: 50px;
    margin-left: 5%;
    position: sticky;
    padding: 50px 50px;
    border-radius: 20px;
    text-align: left;
    width: 90%;
	background: linear-gradient(-45deg,  #192b44, #0f1724, #000417);
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

p:first-letter {
    text-transform: capitalize;
}
/* .reply {
    text-align: right;
    background: linear-gradient(45deg,  #192b44, #0f1724, #000417);
    color: #48a981;
    padding: 25px 50px;
    border-radius: 20px;
    opacity: 1;
    font-family: monospace;
overflow: hidden; 
  border-right: .15em solid orange; 
  white-space: nowrap; 
  margin: 0 auto;
  letter-spacing: .0em; 
  animation: 
    fadein 0.3s ease-in-out,  
    typing 3.5s steps(30, end),
    blink-caret .5s step-end infinite;
} */
.reply {
    text-align: right;
    background: linear-gradient(45deg,  #192b44, #0f1724, #000417);
    color: #48a981;
    padding: 25px 50px;
    border-radius: 20px;
    opacity: 1;
    font-family: monospace;
overflow: hidden; /* Ensures the content is not revealed until the animation */
  animation: 
    fadein 0.3s ease-in-out;  
}

/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange }
}
@keyframes writing {
    0% { content: '   '; }
    25% { content: '•  '; }
    50% { content: '•• '; }
    75% { content: '•••'; }
    100% { content: '   '; }
  }
  
  @keyframes fadein {
    0% {
      opacity: 0;
      transform: scale(0);
      filter: blur(8px);
    }
    100% {
      opacity: 1;
      transform: scale(1.0);
      filter: blur(0px);
    }
  }
p:last-child {
    margin-bottom: 100px;
}
iframe {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
    width: 48%;
    height: 450px;
    margin-block: 10px;
    margin-left: 10px;
    margin-right: 10px;
    padding-block: 20px;
    border-radius: 20px;
    /* opacity: 0.9; */
}
ul {
    text-align: left;
}
.texts {;
    color: white;
    font-size: 25px;
    align-items: left;
    background: #000;
    padding: 25px 50px;
    border-radius: 20px;
    opacity: 1;
    animation: fadein 0.3s ease-in-out;
}
 @keyframes fadein {
    0% {
      opacity: 0;
      transform: scale(0);
      filter: blur(8px);
    }
    100% {
      opacity: 1;
      transform: scale(1.0);
      filter: blur(0px);
    }
  }
/* .texts {
    color: white;
    padding: 25px 50px;
    font-size: 25px;
    align-items: left;
    background: #000;
    padding: 25px 50px;
    border-radius: 20px;
    display: inline;
    opacity: 1;
    animation: fadein 0.3s ease-in-out;
    display: inline-block;
    font-family: monospace;
    white-space: pre;
    opacity: 0.3;
    content: '•••';
    animation: writing 1s linear infinite;
} */

@media only screen and (max-width: 600px) {
  iframe {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
    width: 100%;
    height: 450px;
    margin-block: 10px;
    margin-left: 10px;
    margin-right: 10px;
    padding-block: 20px;
    border-radius: 20px;
    /* opacity: 0.9; */
}
ul {
    text-align: left;
}
.texts {;
    color: white;
    padding: 25px 50px;
    font-size: 25px;
    align-items: left;
    background: #000;
    padding: 25px 50px;
    border-radius: 20px;
}
}
.user-speach-2 {
  position: absolute;
  min-width: 0%;
  max-width: 120%;
    bottom: 5px;
    height: 225px;
    float: inherit;
    left: 0px;
    right: 0px;
  border-radius: 20px;
  padding: 10px;
  color: #fff;
  /* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (max-width: 600px) {
  .user-speach-2 {
    font-size: 14px;
    min-width: 0%;
    bottom: 0px;
    height: 225px;
    float: inherit;
    left: 0px;
    right: 0px;
    border-radius: 20px;
    padding: 10px;
    color: #fff;
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}
.user-speach-3 {
  position: absolute;
  top: 0px;
  font-size: 15px;
  max-width: 25%;
  height: 50px;
  float: inherit;
  right: 45.8%;
  border-radius: 10px;
  color: #fff;
  background-size: 400% 400%;
}
.animation {
  position: absolute;
  bottom: 30px;
  font-size: 15px;
  width: 6%;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
.animation2 {
  position: absolute;
  bottom: 22px;
  min-height: 0px;
  right: 65px;
}
.animation3 {
  position: absolute;
  bottom: -18px;
  font-size: 15px;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
@media only screen and (max-width: 600px) {
.animation3 {
  font-size: 15px;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
 }
}
.animation4 {
  position: absolute;
  bottom: -50px;
  font-size: 15px;
  min-height: 0px;
  left: 0%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
.animation5 {
  position: absolute;
  bottom: -10 0px;
  font-size: 15px; 
  min-height: 0px;
  left: -150px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
.cardColor {
  background: rgba(19, 26, 64, 0.85) !important;
  border-color: white !important;
  color: #fff;
}
.info-contain {
  text-align: center;
}
.txt-green {
  color: #fff;
  font-size: 35px;
  margin-top: 80px;
  display: inline-block;
}

.sm-video {
  display: none; /* Initially hide the video */
  position: fixed; /* Set fixed positioning for the overlay */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999; /* Ensure it's on top of everything */
  width: 100%;
  height: 100%;
}

.sm-video:active {
  display: block; /* Display the video when active class is added */
}

.video {
  position: relative;
  padding-top: -100px;
  padding-bottom: 50px;
  overflow: hidden;
  margin-top: -45px;
}
.video:active {
  position: relative;
  padding-top: -100px;
  padding-bottom: 50px;
  overflow: hidden;
  margin-top: -45px;
  width: 100%;
  height: 100%;
}
.video:after {
  content: "";
  display: block;
  padding-top: 56.25%;
}
.video:hover {
  position: relative;
  padding-top: -100px;
  padding-bottom: 50px;
  overflow: hidden;
  margin-top: -45px;
  width: 100%;
  height: auto;
}
.video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.footer {
  background: #0c161b;
}
.start-animate {
  animation: shadow-pulse 2s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: 0 0 0 75px rgba(0, 0, 0, 0);
  }
}

@keyframes shadow-pulse-big {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 150px rgba(0, 0, 0, 0);
  }
}

.footer {
    width: 100%;
    height: 9.5vh;
    position: fixed;
    bottom: 0px;
    z-index: 10;
    /* background: linear-gradient(-90deg, #0c161b, #0c161b);
    -webkit-animation: gradient 20s ease infinite;
    -animation: gradient 20s ease infinite; */
  }

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.mic {
  width: 80px;
  position: relative;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  opacity: 0.0;
}  
.mic2 {
    width: 30px;
    position: absolute;
    margin-top: 20px;
    left: 0px;
    border-radius: 50%;
    opacity: 1;
  }     
.typing-2 {
  padding: 20px;
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.36em;
  text-align: center;
  background: rgba(37, 50, 68, 0.0);
}


.user-speach {
  position: absolute;
  opacity: 1;
  font-size: 17px;
  line-height: 22px;
  max-width: 42%;
  bottom: 225px;
  height: 0px;
  float: inherit;
  left: -20px;
  border-radius: 10px;
  transform: translate(-0%, -50%);
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (max-width: 600px) {
  .user-speach {
  opacity: 1;
  max-width: 100%;
  bottom: 280px;
  height: 0px;
  float: inherit;
  left: 0%;
  border-radius: 10px;
  /* color: #85c739; */
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}

.typing {
  padding: 15px;
  border-radius: 25px;
  min-width: 0%;
  max-width: 92%;
  margin-left: 50px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;
  text-align: center;
  background: rgba(20, 29, 41, 0.473);
  -webkit-animation: titleAnimation 30s infinite ease;
  -animation: titleAnimation 30s normal forwards ease-in-out;
}
 @keyframes glow4 {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 3px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 1px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 4px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@keyframes titleAnimation {
  0% {
    transform: translateY(0px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  80% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
/* 

@media only screen and (max-width: 600px) {
.typing {
  padding: 15px;
  border-radius: 25px;
  min-width: 0%;
  max-width: 95%;
  margin-left: 10px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.3em;
  text-align: center;
  background: rgba(37, 50, 68, 0.5);
  -webkit-animation: titleAnimation 30s infinite ease;
  -animation: titleAnimation 30s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(0px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  80% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
} */

.fade-in-text {
  font-size: 30px;
  vertical-align: middle;
  color: #c1c3d9;
  opacity: 0;
  -webkit-animation: fadeIn linear 3s forwards;
  -moz-animation: fadeIn linear 3s forwards;
  -o-animation: fadeIn linear 3s forwards;
  -ms-animation: fadeIn linear 3s forwards;
  animation: fadeIn linear 3s forwards;
}

.fade-in-text-sub {
  font-size: 20px;
  vertical-align: middle;
  color: #c1c3d9;
  opacity: 0;
  -webkit-animation: fadeIn linear 3s forwards;
  -moz-animation: fadeIn linear 3s forwards;
  -o-animation: fadeIn linear 3s forwards;
  -ms-animation: fadeIn linear 3s forwards;
  animation: fadeIn linear 3s forwards;
  animation-delay: 1s;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}



.typing2 {
  padding: 15px;
  /* background: rgba(37, 50, 68, 0.6);
    border-radius: 15px; */
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;

  background: rgba(37, 50, 68, 0.2);
  -webkit-animation: titleAnimation 20s 1 ease;
  -animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(-48 px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    -webkit-animation-iteration-count: 1;
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  80% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}

@media only screen and (max-width: 600px) {
.typing2 {
  padding: 15px;
  /* background: rgba(37, 50, 68, 0.6);
    border-radius: 15px; */
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;

  background: rgba(37, 50, 68, 0.2);
  -webkit-animation: titleAnimation 20s 1 ease;
  -animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(-48 px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    -webkit-animation-iteration-count: 1;
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  80% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
}  

h2 {
  font-size: 75px;
  text-transform: uppercase;
}
h1 span {
  animation-delay: 0.6s;
  -webkit-animation-fill-mode: forwards;
}

h2 {
  top: 0;
  position: absolute;
}

.space {
  height: 20px;
}

p.copyright {
    position: absolute;
    width: 100%;
    color: #fff;
    line-height: 10px;
    font-size: 0.7em;
    text-align: right;
    bottom: -25px;
    margin-left: -34px;
  }
.close-btn-chat {
  position: top-right;
  width: 100px;
  height: 100px;
  background: linear-gradient(90deg, #0c161b, #0c161b);
}
.mic-animate {
    margin-top: -30px;
    width: 120px;
    height: 120px;
    /* animation: shadow-pulse 1s infinite; */
    cursor: pointer;
  }

@media only screen and (max-width: 600px) {
  p.copyright {
    position: absolute;
    width: 100%;
    color: #fff;
    line-height: 10px;
    font-size: 0.8em;
    text-align: right;
    bottom: 0px;
    left: 20px;
    opacity: 0.3;
  }
}
</style>

<style lang="scss" scoped>
.animate-word {
  opacity: 1;
  animation: text-flicker 1s ease-in-out;
}

@keyframes text-flicker {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
@keyframes writing {
    0% { content: '   '; }
    25% { content: '•  '; }
    50% { content: '•• '; }
    75% { content: '•••'; }
    100% { content: '   '; }
  }
  
  @keyframes fadein {
    0% {
      opacity: 0;
      transform: scale(0);
      filter: blur(8px);
    }
    100% {
      opacity: 1;
      transform: scale(1.0);
      filter: blur(0px);
    }
  }
  
  * {
    box-sizing: border-box;
  }
  
  body {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0px;
    overflow: hidden;
    font-family: Arial;
    line-height: 1.5em;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f8;
  }
  
  code {
    border: 1px solid #d0d0d0;
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 3px;
  }
  
  .chat {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: calc(1024px - 32px);
    max-height: calc(600px - 32px);
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: white;
    margin: 16px;
  }
  
  .chat .chat-left {
    position: absolute;
    width: 50%;
    padding: 16px;
    overflow: auto;
    max-height: 100%;
  }
  
  .chat .chat-right {
    position: absolute;
    left: 50%;
    width: 50%;
    top: 0%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
  }
  
  .chat .chat-right .chat-header {
    flex-shrink: 0;
    display: none;
    padding: 0px 16px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #f8f8f8;
  }
  
  .chat .chat-right .chat-content {
    flex-grow: 1;
    padding: 16px;
    overflow: auto;
  }
  
  .chat .chat-right .chat-content .message {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 16px;
  }
  
  .chat .chat-right .chat-content .message .content {
    border-radius: 10px;
    background-color: #f8f8f8;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    padding: 8px 16px;
    white-space: pre-wrap;
  }
  
  .chat .chat-right .chat-content .message .content .chunk {
    display: inline;
    opacity: 1;
    animation: fadein 0.3s ease-in-out;
  }
  
  .chat .chat-right .chat-content .message.assistant .content:empty:after {
    display: inline-block;
    font-family: monospace;
    white-space: pre;
    opacity: 0.3;
    content: '•••';
    animation: writing 1s linear infinite;
  }
  
  .chat .chat-right .chat-content .message.user {
    justify-content: flex-end;
  }
  
  .chat .chat-right .chat-content .message.user .content {
    color: white;
    background-color: #0069cf;
  }
  
  .chat .chat-right .chat-input {
    flex-shrink: 0;
    padding: 16px;
    position: relative;
    font-size: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #f8f8f8;
  }
  
  .chat .chat-right .chat-input form {
    padding: 0px;
    margin: 0px;
  }
  
  .chat .chat-right .chat-input textarea {
    display: block;
    font-family: Arial;
    font-size: 16px;
    line-height: 1.5em;
    width: 100%;
    border-radius: 3px;
    resize: none;
    height: 80px;
    padding: 8px 16px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  }
  
  .chat .chat-right .chat-input .chat-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 8px;
  }
  
  .chat .chat-right .chat-input .chat-buttons .link {
    flex-grow: 1;
  }
  
  .chat .chat-right .chat-input .chat-buttons button {
    color: white;
    font-size: 16px;
    padding: 8px 16px;
    background-color: #0069cf;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    cursor: pointer;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  }
  
  .chat .chat-right .chat-input .chat-buttons button:hover {
    transform: translateY(-2px);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
  }
  
  .chat .chat-right .chat-input .chat-buttons button:active {
    transform: translateY(1px);
    box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.6);
  }
  
  @media only screen and (max-width: 768px) {
    body {
      position: fixed;
    }
    .chat .chat-left {
      display: none;
    }
    .chat {
      margin: 0px;
      max-height: 100%;
      border: none;
      border-radius: 0px;
    }
    .chat .chat-right {
      left: 0%;
      width: 100%;
      border-left: 0px;
    }
    .chat .chat-right .chat-header {
      display: block;
    }
  }
</style>